import Vue from 'vue';
import Router from 'vue-router';
import { getDBOperationPermission } from "common/js/storage";

// 管理员登录--db
const CmsAdminLogin = () => import('views/dbviews/login/AdminLogin');
// 管理员商品预览--db
const CmsPreviewProduct = () => import('views/dbviews/commodity/PreviewProduct');
// cms--首页
const CmsdbViewsIndex = () => import('views/dbviews/index');
// 侧边菜单栏--首页
const CmsHome = () => import('views/dbviews/home/');
const CmsHomeIndex = () => import('views/dbviews/home/index');
// 侧边菜单栏--首页--二级菜单--系统首页(index)
const CmsSystemIndex = () => import('views/dbviews/home/system-home/');
// 侧边菜单栏--首页--二级菜单--系统首页
const CmsSystemHome = () => import('views/dbviews/home/system-home/SystemHome');
// 侧边菜单栏--首页--二级菜单--账号设置(index)
const CmsAccount = () => import('views/dbviews/home/account-setting/');
// 侧边菜单栏--首页--二级菜单--账号设置
const CmsAccountSetting = () => import('views/dbviews/home/account-setting/AccountSetting');
// 侧边菜单栏--首页--二级菜单--账号设置/修改密码
const CmsChangePassword = () => import('views/dbviews/home/account-setting/ChangePassword');
// 侧边菜单栏--首页--二级菜单--账号设置/更改手机
const CmsChangePhone = () => import('views/dbviews/home/account-setting/ChangePhone');
// 侧边菜单栏--首页--二级菜单--操作日志(index)
const CmsLog = () => import('views/dbviews/home/operation-log/');
// 侧边菜单栏--首页--二级菜单--操作日志
const CmsOperationLog = () => import('views/dbviews/home/operation-log/OperationLog');
// 侧边菜单栏--首页--二级菜单--操作日志/登录日志
const CmsLoginsDetail = () => import('views/dbviews/home/operation-log/LoginsDetail');
// 侧边菜单栏--首页--二级菜单--操作日志/操作记录
const CmsOperationsDetail = () => import('views/dbviews/home/operation-log/OperationsDetail');
// 侧边菜单栏--首页--二级菜单--消息通知
const CmsMessage = () => import('views/dbviews/home/message/Message');
// 侧边菜单栏--首页--二级菜单--数据报表（index）
const CmsDataReportIndex = () => import('views/dbviews/home/data-report/index.vue');
// 侧边菜单栏--首页--二级菜单--数据报表/销售数据报表
const CmsDataReportSales = () => import('views/dbviews/home/data-report/sales.vue');
// 侧边菜单栏--首页--二级菜单--数据报表/商品数据报表
const CmsDataReportGoods = () => import('views/dbviews/home/data-report/goods.vue');
// 侧边菜单栏--首页--二级菜单--数据报表/客户数据报表
const CmsDataReportCustomer = () => import('views/dbviews/home/data-report/customer.vue');

// 侧边菜单栏--商品
const CmsCommodity = () => import('views/dbviews/commodity/');
const CmsCommodityIndex = () => import('views/dbviews/commodity/index');
// 侧边菜单栏--商品--二级菜单--商品列表(index)
const CmsList = () => import('views/dbviews/commodity/commodity-list/');
// 侧边菜单栏--商品--二级菜单--商品列表
const CmsCommodityList = () => import('views/dbviews/commodity/commodity-list/CommodityList');
// 侧边菜单栏--商品--二级菜单--商品列表/新增商品
const CmsAddCommodity = () => import('views/dbviews/commodity/commodity-list/AddCommodity');
// 侧边菜单栏--商品--二级菜单--商品辅助--三级菜单--商品价格
const CmsPriceManage = () => import('views/dbviews/commodity/price-manage/PriceManage');
// 侧边菜单栏--商品--二级菜单--商品辅助--三级菜单--分类管理
const CmsSortManage = () => import('views/dbviews/commodity/sort-manage/SortManage');
// 侧边菜单栏--商品--二级菜单--商品辅助--三级菜单--商品标签
const CmsCommodityTag = () => import('views/dbviews/commodity/commodity-classify/CommodityTag');
// 侧边菜单栏--商品--二级菜单--商品辅助--三级菜单--商品品牌
const CmsCommodityBrand = () => import('views/dbviews/commodity/commodity-brand/CommodityBrand');
// 侧边菜单栏--商品--二级菜单--商品辅助--三级菜单--商品品牌
const CmsParameterManage = () => import('views/dbviews/commodity/parameter-manage/ParameterManage');
// 侧边菜单栏--商品--二级菜单--运费管理(index)
const CmsFreight = () => import('views/dbviews/commodity/freight-manage/');
// 侧边菜单栏--商品--二级菜单--运费管理
const CmsFreightManage = () => import('views/dbviews/commodity/freight-manage/FreightManage');
// 侧边菜单栏--商品--二级菜单--运费管理/新增运费模板
const CmsAddFreightTpl = () => import('views/dbviews/commodity/freight-manage/AddFreightTpl');

// 侧边菜单栏--订单
const CmsOrder = () => import('views/dbviews/order/');
const CmsOrderIndex = () => import('views/dbviews/order/index');
// 侧边栏单栏--订单--二级菜单--订单(index)
const CmsOrderForm = () => import('views/dbviews/order/order-list/');
// 侧边栏单栏--订单--二级菜单--订单
const CmsOrderList = () => import('views/dbviews/order/order-list/OrderList');
// 侧边栏单栏--订单--二级菜单--订单--详情
const CmsOrderDetail = () => import('views/dbviews/order/order-list/OrderDetail');
// 侧边栏单栏--订单--二级菜单--订单--新增订单
const CmsAddOrder = () => import('views/dbviews/order/order-list/AddOrder');
// 侧边栏单栏--订单--二级菜单--退货单
const CmsReturnForm = () => import('views/dbviews/order/purchase-return/');
// 侧边栏单栏--订单--二级菜单--退货单
const CmsOrderReturn = () => import('views/dbviews/order/purchase-return/OrderReturn');
// 侧边栏单栏--订单--二级菜单--退货单/退货详情
const CmsCancellationDetail = () => import('views/dbviews/order/purchase-return/CancellationDetail');
// 侧边栏单栏--订单--二级菜单--选品单
const CmsSelectForm = () => import('views/dbviews/order/select-order/');
// 侧边栏单栏--订单--二级菜单--选品单
const CmsSelectOrder = () => import('views/dbviews/order/select-order/SelectOrder');
// 侧边栏单栏--订单--二级菜单--返修单（index）
const CmsRepairForm = () => import('views/dbviews/order/repair-order/');
// 侧边栏单栏--订单--二级菜单--返修单
const CmsRepairList = () => import('views/dbviews/order/repair-order/repairList');
// 侧边栏单栏--订单--二级菜单--订单--新增返修单
const CmsAddRepair = () => import('views/dbviews/order/repair-order/AddRepair');
// 侧边栏单栏--订单--二级菜单--关联选品
const CmsRelationSelect = () => import('views/dbviews/order/select-order/RelationSelect');

// 侧边菜单栏--库存
const CmsInventory = () => import('views/dbviews/inventory/');
const CmsInventoryIndex = () => import('views/dbviews/inventory/index');
// 侧边菜单栏--库存--二级菜单--商品库存
const CmsGoodsInventory = () => import('views/dbviews/inventory/goods-inventory/GoodsInventory');
// 侧边菜单栏--库存--二级菜单--商品入库(index)
const CmsStorage = () => import('views/dbviews/inventory/goods-storage/');
// 侧边菜单栏--库存--二级菜单--库存编辑
const CmsGoodsEdit = () => import('views/dbviews/inventory/goods-edit/GoodsEdit');
// 侧边菜单栏--库存--二级菜单--商品入库
const CmsGoodsStorage = () => import('views/dbviews/inventory/goods-storage/GoodsStorage');
// 侧边菜单栏--库存--二级菜单--入库详情
const CmsStorageDetail = () => import('views/dbviews/inventory/goods-storage/StorageDetail');
// 侧边菜单栏--库存--二级菜单--新增入库
const CmsIncreasedStorage = () => import('views/dbviews/inventory/goods-storage/IncreasedStorage');
// 侧边菜单栏--库存--二级菜单--商品出库(index)
const CmsOutStorage = () => import('views/dbviews/inventory/leave-storage/');
// 侧边菜单栏--库存--二级菜单--商品出库
const CmsLeaveStorage = () => import('views/dbviews/inventory/leave-storage/LeaveStorage');
// 侧边菜单栏--库存--二级菜单--出库详情
const CmsOutStorageDetail = () => import('views/dbviews/inventory/leave-storage/OutStorageDetail');
// 侧边菜单栏--库存--二级菜单--新增出库
const CmsIncreasedOutStorage = () => import('views/dbviews/inventory/leave-storage/IncreasedOutStorage');
// 侧边菜单栏--库存--二级菜单--仓库设置
const CmsWarehouseSetting = () => import('views/dbviews/inventory/warehouse-setting/WarehouseSetting');

// 侧边菜单栏--客户
const CmsClient = () => import('views/dbviews/client/');
const CmsClientIndex = () => import('views/dbviews/client/index');
// 侧边菜单栏--客户--二级菜单--客户管理(index)
const CmsClientManageIndex = () => import('views/dbviews/client/client-manage/');
// 侧边菜单栏--客户--二级菜单--客户管理
const CmsClientManage = () => import('views/dbviews/client/client-manage/ClientManage');
// 侧边菜单栏--客户--二级菜单--客户管理--详情
const CmsClientDetail = () => import('views/dbviews/client/client-manage/ClientDetail');
// 侧边菜单栏--客户--二级菜单--客户管理--优惠券
const CmsClientCoupon = () => import('views/dbviews/client/client-manage/Coupon.vue');
// 侧边菜单栏--客户--二级菜单--客户管理--购买记录
const CmsPurchaseRecord = () => import('views/dbviews/client/client-manage/purchase-record.vue');
// 侧边菜单栏--客户--二级菜单--标签管理
const CmsTagManage = () => import('views/dbviews/client/tag-manage/TagManage');
// 侧边菜单栏--客户--二级菜单--客户等级
const CmsClientGrade = () => import('views/dbviews/client/client-grade/ClientGrade');
// 侧边菜单栏--客户--二级菜单--登录统计(index)
const CmsLoginStatisticsIndex = () => import('views/dbviews/client/login-statistics/index.vue');
// 侧边菜单栏--客户--二级菜单--登录统计
const CmsLoginStatistics = () => import('views/dbviews/client/login-statistics/login-statistics.vue');
// 侧边菜单栏--客户--二级菜单--登录详情
const CmsLoginDetail = () => import('views/dbviews/client/login-statistics/LoginDetails.vue');

// 侧边菜单栏--商城
const CmsMall = () => import('views/dbviews/mall/');
const CmsMallIndex = () => import('views/dbviews/mall/index');
// 侧边菜单栏--商城--二级菜单--顶部栏(index)
const CmsMallTop = () => import('views/dbviews/mall/mall-top/');
// 侧边菜单栏--商城--二级菜单--顶部栏(默认页面)
const CmsMallTopList = () => import('views/dbviews/mall/mall-top/MallTopList');
// 侧边菜单栏--商城--二级菜单--新增顶部栏
const CmsAddMallTop = () => import('views/dbviews/mall/mall-top/AddMallTop');
// 侧边菜单栏--商城--二级菜单--菜单栏
const CmsMallSide = () => import('views/dbviews/mall/mall-side/MallSide');
// 侧边菜单栏--商城--二级菜单--信息栏(index)
const CmsMallBottom = () => import('views/dbviews/mall/mall-bottom/');
// 侧边菜单栏--商城--二级菜单--信息栏
const CmsInformationBar = () => import('views/dbviews/mall/mall-bottom/InformationBar');
// 侧边菜单栏--商城--二级菜单--信息栏/编辑详情
const CmsEditDetail = () => import('views/dbviews/mall/mall-bottom/EditDetail');
// 侧边菜单栏--商城--二级菜单--手机装修
const CmsPhoneDecorate = () => import('views/dbviews/mall/phone-decorate/PhoneDecorate');
// 侧边菜单栏--商城--二级菜单--客服设置
const CmsCustomerService = () => import('views/dbviews/mall/customer-service/CustomerService');
// 侧边菜单栏--商城--二级菜单--手机自定义页面
const CmsPhoneCustomize = () => import('views/dbviews/mall/phone-customize/PhoneCustomize');

// 侧边菜单栏--营销
const CmsMarketing = () => import('views/dbviews/marketing/');
const CmsMarketingIndex = () => import('views/dbviews/marketing/index');
// 侧边菜单栏--营销--二级菜单--商品促销(index)
const CmsPromotionIndex = () => import('views/dbviews/marketing/goods-promotion/');
// 侧边菜单栏--营销--二级菜单--商品促销
const CmsGoodsPromotion = () => import('views/dbviews/marketing/goods-promotion/GoodsPromotion');
// 侧边菜单栏--营销--二级菜单--新增促销
const CmsAddPromotion = () => import('views/dbviews/marketing/goods-promotion/AddPromotion');
// 侧边菜单栏--营销--二级菜单--商品推荐
const CmsGoodsRecommend = () => import('views/dbviews/marketing/goods-recommend/GoodsRecommend');
// 侧边菜单栏--营销--二级菜单--套餐管理(index)
const CmsPackageIndex = () => import('views/dbviews/marketing/package-manage/');
// 侧边菜单栏--营销--二级菜单--套餐管理
const CmsPackageManage = () => import('views/dbviews/marketing/package-manage/PackageManage');
// 侧边菜单栏--营销--二级菜单--新增套餐
const CmsAddPackage = () => import('views/dbviews/marketing/package-manage/AddPackage');
// 侧边菜单栏--营销--二级菜单--查看套餐
const CmsPackageDetail = () => import('views/dbviews/marketing/package-manage/PackageDetail');
// 侧边菜单栏--营销--二级菜单--广告弹窗
const CmsAdvertisingPopup = () => import('views/dbviews/marketing/advertising-popup/AdvertisingPopup');
// 侧边菜单栏--营销--二级菜单--优惠劵(index)
const CmsCouponIndex = () => import('views/dbviews/marketing/coupon/');
// 侧边菜单栏--营销--二级菜单--优惠劵列表
const CmsCouponList = () => import('views/dbviews/marketing/coupon/CouponList');
// 侧边菜单栏--营销--二级菜单--优惠劵详情
const CmsCouponDetail = () => import('views/dbviews/marketing/coupon/CouponDetail');
// 侧边菜单栏--营销--二级菜单--新增优惠券
const CmsAddCoupon = () => import('views/dbviews/marketing/coupon/AddCoupon');
// 侧边菜单栏--营销--二级菜单--发放优惠券
const CmsAssignCoupon = () => import('views/dbviews/marketing/coupon/AssignCoupon');
// 侧边菜单栏--营销--二级菜单--活动竞价(index)
const CmsBiddingActivitiesIndex = () => import('views/dbviews/marketing/bidding-activities/');
// 侧边菜单栏--营销--二级菜单--活动竞价
const CmsBiddingActivities = () => import('views/dbviews/marketing/bidding-activities/biddingActivities');
// 侧边菜单栏--营销--二级菜单--活动竞价详情
const CmsBiddingDetails = () => import('views/dbviews/marketing/bidding-activities/biddingDetails');
// 侧边菜单栏--营销--二级菜单--竞价活动审核商品
const Review = () => import('views/dbviews/marketing/bidding-activities/review');
// 侧边菜单栏--营销--二级菜单--竞价活动入围确认
const Shortlist = () => import('views/dbviews/marketing/bidding-activities/shortlist');
// 侧边菜单栏--营销--二级菜单--展位活动(index)
const CmsStandActivityIndex = () => import('views/dbviews/marketing/stand-activity/');
// 侧边菜单栏--营销--二级菜单--展位活动
const CmsStandActivity = () => import('views/dbviews/marketing/stand-activity/standActivity');
// 侧边菜单栏--营销--二级菜单--添加平台商品
const CmsStandAddGoods = () => import('views/dbviews/marketing/stand-activity/addGoods');
// 侧边菜单栏--营销--二级菜单--查看竞价
const CmsStandLookDetails = () => import('views/dbviews/marketing/stand-activity/lookDetails');

// 侧边菜单栏--数据
const CmsDatas = () => import('views/dbviews/datas/');
const CmsDatasIndex = () => import('views/dbviews/datas/index');
// 侧边菜单栏--数据--二级菜单--数据
const CmsData = () => import('views/dbviews/datas/data/Data');

// 侧边菜单栏--设置
const CmsSetting = () => import('views/dbviews/setting/');
const CmsSettingIndex = () => import('views/dbviews/setting/index');

// 侧边菜单栏--设置--二级菜单--部门管理(index)
const CmsDepartment = () => import('views/dbviews/setting/department/');
// 侧边菜单栏--设置--二级菜单--部门管理
const CmsDepartmentManage = () => import('views/dbviews/setting/department/DepartmentManage');
// 侧边菜单栏--设置--二级菜单--部门权限
const CmsDepartmentAuthority = () => import('views/dbviews/setting/department/DepartmentAuthority');
// 侧边菜单栏--设置--二级菜单--员工管理(index)
const CmsEmployee = () => import('views/dbviews/setting/employee/');
// 侧边菜单栏--设置--二级菜单--员工管理
const CmsEmployeeManage = () => import('views/dbviews/setting/employee/EmployeeManage');
// 侧边菜单栏--设置--二级菜单--员工新增账号
const CmsEmployeeAddAccount = () => import('views/dbviews/setting/employee/EmployeeAddAccount');
// 侧边菜单栏--设置--二级菜单--员工权限
const CmsEmployeeAuthority = () => import('views/dbviews/setting/employee/EmployeeAuthority');
// 侧边菜单栏--设置--二级菜单--员工修改账号
const CmsEmployeeReviseAccount = () => import('views/dbviews/setting/employee/EmployeeReviseAccount');
// 侧边菜单栏--设置--二级菜单--收款设置--线上支付
const CmsOnlinePay = () => import('views/dbviews/setting/online-pay/OnlinePay');
// 侧边菜单栏--设置--二级菜单--收款设置--线下支付
const CmsOfflinePay = () => import('views/dbviews/setting/offline-pay/OfflinePay');
// 侧边菜单栏--设置--二级菜单--业务流程设置
const CmsBusinessSetting = () => import('views/dbviews/setting/business-setting/BusinessSetting');
// 侧边菜单栏--设置--二级菜单--系统设置
const CmsSystemSetting = () => import('views/dbviews/setting/system-setting/SystemSetting');

// 侧边菜单栏--应用（预留）
const CmsApply = () => import('views/dbviews/apply/');
const CmsApplyMenu = () => import('views/dbviews/apply/apply-menu/ApplyMenu');
const CmsLogisticsIntroduce = () => import('views/dbviews/apply/logistics/LogisticsIntroduce');
const CmsERPIntroduce = () => import('views/dbviews/apply/ERP/ERPIntroduce');
const CmsERPConfigure = () => import('views/dbviews/apply/ERP/ERPConfigure');
const CmsSupplierIntroduce = () => import('views/dbviews/apply/supplier/SupplierIntroduce');
const CmsSupplierConfigure = () => import('views/dbviews/apply/supplier/SupplierConfigure');
const CmsSelectionIntroduce = () => import('views/dbviews/apply/selection/SelectionIntroduce');
const CmsDistributionIntroduce = () => import('views/dbviews/apply/distribution/distributionIntroduce');
const CmsIntegralContent = () => import('views/dbviews/apply/integral/IntegralCentent.vue');
const CmsPointsAccount = () => import('views/dbviews/apply/integral/PointsAccount.vue');
const CmsIntegralDetailed = () => import('views/dbviews/apply/integral/IntegralDetailed.vue');
const CmsIntegralSettingList = () => import('views/dbviews/apply/integral/IntegralSettingList.vue');
const CmsIntegralSetting = () => import('views/dbviews/apply/integral/IntegralSetting.vue');

// 前台商城页面
const XbviewsIndex = () => import('views/xbviews/');
// 前台活动商品预览--xb
const xbPreviewProduct = () => import('views/xbviews/product/Previewpage');
// 前台商城首页面
const Homepage = () => import('views/xbviews/home/Home');
// 前台商城首页切换面
const HomeView = () => import('views/xbviews/home/HomeView');
// 前台商城用户登录页面
const UserLogin = () => import('views/xbviews/login/UserLogin');
// 前台商城用户注册页面
const UserRegister = () => import('views/xbviews/login/UserRegister');
// 前台商城用户找回密码页面
const UserPassword = () => import('views/xbviews/login/UserPassword');
// 前台商城用户商品详情页面
const Product = () => import('views/xbviews/product/Product');
// 前台商城用户商品搜索页面
const Search = () => import('views/xbviews/search/SearchPage');

// 前台商城商品列表页面
const Goods = () => import('views/xbviews/goods/');
// 前台商城商品列表页面(优惠劵商品)
const CouponGoods = () => import('views/xbviews/goods/CouponGoods');
// 前台商城商品列表页面(促销商品)
const PromotionGoods = () => import('views/xbviews/goods/PromotionGoods');

// 前台商城用户帮助中心页面
const Service = () => import('views/xbviews/service/Service');
// 前台商城活动卖场
const Activity = () => import('views/xbviews/activity/activity');

// 前台商城用户--个人中心页面(index)
const Personal = () => import('views/xbviews/personal/');
// 前台商城用户--个人中心菜单页面(index)
const PersonalMenu = () => import('views/xbviews/personal/personal-menu/');
// 前台商城用户--个人中心--首页页面
const PersonalCenter = () => import('views/xbviews/personal/personal-menu/PersonalHome');
// 前台商城用户--我的信息--个人信息
const PersonalInfo = () => import('views/xbviews/personal/personal-menu/PersonalInfo');
// 前台商城用户--我的信息--个人信息--修改手机
const UpdateMobile = () => import('views/xbviews/personal/personal-menu/UpdateMobile')
// 前台商城用户--我的信息--个人信息--修改密码
const UpdatePassword = () => import('views/xbviews/personal/personal-menu/UpdatePassword')
// 前台商城用户--我的信息--收货地址
const ShippingAddress = () => import('views/xbviews/personal/personal-menu/ShippingAddress');
// 前台商城用户--我的信息--购物车
const ShoppingCart = () => import('views/xbviews/personal/personal-menu/ShoppingCart');
// 前台商城用户--个人中心--订货单页面
const Order = () => import('views/xbviews/personal/personal-menu/Order');
// 前台商城用户--个人中心--返修单页面
const ReturnOrder = () => import('views/xbviews/personal/personal-menu/ReturnOrder');
// 前台商城用户--个人中心--订货单--详情
const OrderDetail = () => import('views/xbviews/personal/personal-alone/OrderDetail');
// 前台商城用户--个人中心--优惠券列表
const CouponList = () => import('views/xbviews/personal/personal-menu/CouponList')
// 前台商城用户--个人中心--退货单页面
const OrderReturn = () => import('views/xbviews/personal/personal-menu/OrderReturn');
// 前台商城用户--个人中心--选品单页面
const SelectOrder = () => import('views/xbviews/personal/personal-menu/SelectOrder');
// 前台商城用户--个人中心--收藏页面
const Collection = () => import('views/xbviews/personal/personal-menu/Collection');
// 前台商城用户--个人中心--商品信息
const Message = () => import('views/xbviews/personal/personal-menu/Message');
// 前台商城用户--个人中心--积分中心
const Integral = () => import('views/xbviews/personal/personal-menu/Integral');
// 前台商城用户个人中心退货单编辑页面
const OrderReturnWrite = () => import('views/xbviews/personal/personal-alone/OrderReturnWrite');
// 前台商城用户个人中心退货单详情
const OrderReturnDetail = () => import('views/xbviews/personal/personal-alone/OrderReturnDetail')
// 前台商城用户个人中心发起退单页面
const LaunchOrderReturn = () => import('views/xbviews/personal/personal-alone/LaunchOrderReturn');
// 购物车结算--确认订单
const ConfirmOrder = () => import('views/xbviews/settlement/ConfirmOrder');
// 购物车结算--确认支付
const ConfirmPay = () => import('views/xbviews/settlement/ConfirmPay');
//微信支付
const WeChatPay = () => import('views/xbviews/settlement/weChatPay');
// 选品池结算--确认选品
const ConfirmSelection = () => import('views/xbviews/settlement/ConfirmSelection');

//承运商Index
const SplViewsIndex = () => import('views/splviews/');
//承运商商品Index
const SplGoods = () => import('views/splviews/spl-goods/');
// 商品--二级菜单--商品列表(index)
const SplList = () => import('views/splviews/spl-goods/goods-list/');
// 商品--二级菜单--商品列表
const SplGoodsList = () => import('views/splviews/spl-goods/goods-list/GoodsList');
// 商品--二级菜单--商品列表/新增商品
const SplAddGoods = () => import('views/splviews/spl-goods/goods-list/AddGoods');
// 商品--二级菜单--商品价格(index)
const SplPriceManage = () => import('views/splviews/spl-goods/price-manage/index.vue');
// 商品--二级菜单--商品价格
const SplPriceManageList = () => import('views/splviews/spl-goods/price-manage/PriceMange.vue');
//承运商选品订单Index
const SplOrder = () => import('views/splviews/spl-order/');
//账号--二级菜单--资料修改
const SplSelectOrder = () => import('views/splviews/spl-order/select-order/SelectOrder');
//购样单（index）
const SplSampleOrderIndex = () => import('views/splviews/spl-order/sample-order');
//购样单
const SplSampleOrder = () => import('views/splviews/spl-order/sample-order/sampleOrder');
// 供应商侧边栏单栏--订单--二级菜单--订单--详情
const SplsampleDetail = () => import('views/splviews/spl-order/sample-order/sampleDetail');
//承运商账号Index
const SplAccount = () => import('views/splviews/spl-account/');
//账号--二级菜单--资料修改
const SplAccountUpdate = () => import('views/splviews/spl-account/account/Account');
// 侧边菜单栏--库存
const SqlInventory = () => import('views/splviews/inventory/');
const SqlInventoryIndex = () => import('views/splviews/inventory/index');
// 侧边菜单栏--库存--二级菜单--商品库存
const SqlGoodsInventory = () => import('views/splviews/inventory/goods-inventory/GoodsInventory');
// 侧边菜单栏--库存--二级菜单--商品入库(index)
const SqlStorage = () => import('views/splviews/inventory/goods-storage/');
// 侧边菜单栏--库存--二级菜单--商品入库
const SqlGoodsStorage = () => import('views/splviews/inventory/goods-storage/GoodsStorage');
// 侧边菜单栏--库存--二级菜单--入库详情
const SqlStorageDetail = () => import('views/splviews/inventory/goods-storage/StorageDetail');
// 侧边菜单栏--库存--二级菜单--新增入库
const SqlIncreasedStorage = () => import('views/splviews/inventory/goods-storage/IncreasedStorage');
// 侧边菜单栏--库存--二级菜单--库存编辑
const SqlGoodsEdit = () => import('views/splviews/inventory/goods-edit/GoodsEdit');
//营销Index
const SplBidding = () => import('views/splviews/spl-bidding/');
//活动竞价(index)
const SplBiddingActivitiesIndex = () => import('views/splviews/spl-bidding/bidding-activities/');
const SplBiddingActivities = () => import('views/splviews/spl-bidding/bidding-activities/biddingActivities.vue');
//竞价详情
const SplBiddingDetails = () => import('views/splviews/spl-bidding/bidding-activities/biddingDetails.vue');
//规则编辑
const SplBiddingModifyRule = () => import('views/splviews/spl-bidding/bidding-activities/modifyRule.vue');
//竞价通知
const SplBiddingMessage = () => import('views/splviews/spl-bidding/bidding-message/bidding-message.vue');
//展位竞价Index
const SplBiddingStandIndex = () => import('views/splviews/spl-bidding/bidding-stand/');
//展位竞价
const SplBiddingStandBidding = () => import('views/splviews/spl-bidding/bidding-stand/biddingStand.vue');
//展位详情
const SplStandDetails = () => import('views/splviews/spl-bidding/bidding-stand/standDetails.vue');
//承运商登录Index
const SplUserLogin = () => import('views/splviews/spl-login/');
const SplLogin = () => import('views/splviews/spl-login/SplLogin');
const SplRegister = () => import('views/splviews/spl-login/SplRegister');
const SplPassword = () => import('views/splviews/spl-login/SplPassword');



const Page404 = () => import('views/Page404');
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: XbviewsIndex,
      redirect: '/homepage',
      children: [
        {
          path: 'homepage',
          name: 'homepage',
          component: Homepage,
          children: [{
            path: '/homepage/:url',
            name: '/homepage/:url',
            component: HomeView
          }]
        },
        {
          path: 'user-login',
          name: 'user-login',
          component: UserLogin
        },
        {
          path: 'user-register',
          name: 'user-register',
          component: UserRegister
        },
        {
          path: 'user-password',
          name: 'user-password',
          component: UserPassword
        },
        {
          path: 'product',
          name: 'product',
          component: Product
        },
        {
          // xb 活动商品预览
          path: '/preview-product',
          component: xbPreviewProduct
        },
        {
          path: 'search',
          name: 'search',
          component: Search
        },
        {
          path: 'goods',
          name: 'goods',
          component: Goods,
          children: [
            {
              path: 'coupon-goods',
              name: 'coupon-goods',
              component: CouponGoods
            },
            {
              path: 'promotion-goods',
              name: 'promotion-goods',
              component: PromotionGoods
            }
          ]
        },
        {
          path: 'service',
          name: 'service',
          component: Service
        },
        {
          path: 'activity',
          name: 'activity',
          component: Activity
        },
        {
          path: 'personal',
          name: 'personal',
          component: Personal,
          redirect: '/personal/personal-menu',
          children: [
            {
              path: 'personal-menu',
              name: 'personal-menu',
              component: PersonalMenu,
              redirect: '/personal/personal-menu/xb-center',
              children: [
                {
                  path: 'xb-center',
                  name: 'xb-center',
                  component: PersonalCenter
                },
                {
                  path: 'xb-info',
                  name: 'xb-info',
                  component: PersonalInfo
                },
                {
                  path: 'xb-update-mobile',
                  name: 'xb-update-mobile',
                  component: UpdateMobile
                },
                {
                  path: 'xb-update-password',
                  name: 'xb-update-password',
                  component: UpdatePassword
                },
                {
                  path: 'xb-shipping',
                  name: 'xb-shipping',
                  component: ShippingAddress
                },
                {
                  path: 'xb-shopping-cart',
                  name: 'xb-shopping-cart',
                  component: ShoppingCart
                },
                {
                  path: 'xb-order',
                  name: 'xb-order',
                  component: Order
                },
                {
                  path: 'xb-order-return',
                  name: 'xb-order-return',
                  component: OrderReturn
                },
                {
                  path: 'xb-select-order',
                  name: 'xb-select-order',
                  component: SelectOrder
                },
                {
                  path: 'xb-return-order',
                  name: 'xb-return-order',
                  component: ReturnOrder
                },
                {
                  path: 'xb-collection',
                  name: 'xb-collection',
                  component: Collection
                },
                {
                  path: 'xb-coupon-list',
                  name: 'xb-coupon-list',
                  component: CouponList
                },
                {
                  path: 'xb-message',
                  name: 'xb-message',
                  component: Message
                },
                {
                  path: 'xb-integral',
                  name: 'xb-integral',
                  component: Integral
                },
              ]
            },
            {
              path: 'xb-order-return-write',
              name: 'xb-order-return-write',
              component: OrderReturnWrite
            },
            {
              path: 'xb-order-return-detail',
              name: 'xb-order-return-detail',
              component: OrderReturnDetail
            },
            {
              path: 'xb-launch-order-return',
              name: 'xb-launch-order-return',
              component: LaunchOrderReturn
            },
            {
              path: 'xb-order-detail',
              name: 'xb-order-detail',
              component: OrderDetail
            }
          ]
        },
        {
          name: 'confirm-order',
          path: 'confirm-order',
          component: ConfirmOrder
        },
        {
          name: 'confirm-pay',
          path: 'confirm-pay',
          component: ConfirmPay,
        },
        {
          name: 'weChat-pay',
          path: 'weChat-pay',
          component: WeChatPay
        },
        {
          name: 'confirm-selection',
          path: 'confirm-selection',
          component: ConfirmSelection
        }
      ]
    },
    {
      // db 登录页面
      path: '/admin/login',
      component: CmsAdminLogin
    },
    {
      // db 商品预览
      path: '/admin/preview-product',
      component: CmsPreviewProduct
    },
    {
      // cms--首页
      path: '/admin',
      component: CmsdbViewsIndex,
      redirect: '/admin/home',
      children: [
        {
          // cms-侧边栏菜单-首页
          name: 'home',
          path: 'home',
          redirect: '/admin/home/index',
          component: CmsHome,
          children: [
            {
              name: 'home-index',
              path: 'index',
              redirect: '/admin/home/system-index',
              component: CmsHomeIndex
            },
            {
              name: 'system-index',
              path: 'system-index',
              redirect: '/admin/home/system-index/system-home',
              component: CmsSystemIndex,
              children: [
                {
                  name: 'system-home',
                  path: 'system-home',
                  component: CmsSystemHome
                }
              ]
            },
            {
              name: 'account',
              path: 'account',
              redirect: '/admin/home/account/account-setting',
              component: CmsAccount,
              children: [
                {
                  name: 'account-setting',
                  path: 'account-setting',
                  component: CmsAccountSetting
                },
                {
                  name: 'change-password',
                  path: 'change-password',
                  component: CmsChangePassword
                },
                {
                  name: 'change-phone',
                  path: 'change-phone',
                  component: CmsChangePhone
                }
              ]
            },
            {
              name: 'log',
              path: 'log',
              redirect: '/admin/home/log/operation-log',
              component: CmsLog,
              children: [
                {
                  name: 'operation-log',
                  path: 'operation-log',
                  component: CmsOperationLog
                },
                {
                  name: 'login-detail',
                  path: 'login-detail',
                  component: CmsLoginsDetail
                },
                {
                  name: 'operation-detail',
                  path: 'operation-detail',
                  component: CmsOperationsDetail
                }
              ]
            },
            {
              name: 'message',
              path: 'message',
              component: CmsMessage,
            },
            {
              name: 'data-report',
              path: 'data-report',
              redirect: to => {
                if (getDBOperationPermission().indexOf('ROLE_INDEX_sale_data_report') !== -1) {
                  return '/admin/home/data-report/sales'
                } else if (getDBOperationPermission().indexOf('ROLE_INDEX_goods_data_report') !== -1) {
                  return '/admin/home/data-report/goods'
                } else if (getDBOperationPermission().indexOf('ROLE_INDEX_customer_data_report') !== -1) {
                  return '/admin/home/data-report/customer'
                } else {
                  return '/admin/home/data-report/sales'
                }
              },
              component: CmsDataReportIndex,
              children: [
                {
                  name: 'sales',
                  path: 'sales',
                  component: CmsDataReportSales,
                  meta: {
                    title: '销售数据报表'
                  }
                },
                {
                  name: 'goods',
                  path: 'goods',
                  component: CmsDataReportGoods,
                  meta: {
                    title: '商品数据报表'
                  }
                },
                {
                  name: 'customer',
                  path: 'customer',
                  component: CmsDataReportCustomer,
                  meta: {
                    title: '客户数据报表'
                  }
                }
              ]
            }
          ]
        },
        {
          // cms-侧边栏菜单-商品
          name: 'commodity',
          path: 'commodity',
          redirect: '/admin/commodity/index',
          component: CmsCommodity,
          children: [
            {
              name: 'commodity-index',
              path: 'index',
              redirect: '/admin/commodity/list',
              component: CmsCommodityIndex
            },
            {
              name: 'list',
              path: 'list',
              component: CmsList,
              redirect: '/admin/commodity/list/commodity-list',
              children: [
                {
                  name: 'commodity-list',
                  path: 'commodity-list',
                  component: CmsCommodityList,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'add-commodity',
                  path: 'add-commodity',
                  component: CmsAddCommodity
                }
              ]
            },
            {
              name: 'price-manage',
              path: 'price-manage',
              component: CmsPriceManage
            },
            {
              name: 'sort-manage',
              path: 'sort-manage',
              component: CmsSortManage
            },
            {
              name: 'commodity-tag',
              path: 'commodity-tag',
              component: CmsCommodityTag
            },
            {
              name: 'commodity-brand',
              path: 'commodity-brand',
              component: CmsCommodityBrand
            }, {
              name: 'parameter-manage',
              path: 'parameter-manage',
              component: CmsParameterManage
            },
            {
              name: 'freight',
              path: 'freight',
              component: CmsFreight,
              redirect: '/admin/commodity/freight/freight-manage',
              children: [
                {
                  name: 'freight-manage',
                  path: 'freight-manage',
                  component: CmsFreightManage
                },
                {
                  name: 'add-freight-tpl',
                  path: 'add-freight-tpl',
                  component: CmsAddFreightTpl
                }
              ]
            }
          ]
        },
        {
          // cms-侧边栏菜单-订单
          name: 'order',
          path: 'order',
          redirect: '/admin/order/order-index',
          component: CmsOrder,
          children: [
            {
              name: 'order-index',
              path: 'order-index',
              redirect: '/admin/order/order-form',
              component: CmsOrderIndex
            },
            {
              name: 'order-form',
              path: 'order-form',
              component: CmsOrderForm,
              redirect: '/admin/order/order-form/order-list',
              children: [
                {
                  name: 'order-list',
                  path: 'order-list',
                  component: CmsOrderList,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'order-detail',
                  path: 'order-detail',
                  component: CmsOrderDetail
                },
                {
                  name: 'add-order',
                  path: 'add-order',
                  component: CmsAddOrder
                }
              ]
            },
            {
              name: 'return-form',
              path: 'return-form',
              component: CmsReturnForm,
              redirect: '/admin/order/return-form/order-return',
              children: [
                {
                  name: 'order-return',
                  path: 'order-return',
                  component: CmsOrderReturn,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'cancellation-detail',
                  path: 'cancellation-detail',
                  component: CmsCancellationDetail
                }
              ]
            },
            {
              name: 'select-form',
              path: 'select-form',
              component: CmsSelectForm,
              redirect: '/admin/order/select-form/select-order',
              children: [
                {
                  name: 'select-order',
                  path: 'select-order',
                  component: CmsSelectOrder,
                }, {
                  name: 'relation-select',
                  path: 'relation-select',
                  component: CmsRelationSelect,
                }
              ]
            },
            {
              name: 'repair-form',
              path: 'repair-form',
              component: CmsRepairForm,
              redirect: '/admin/order/repair-form/repair-list',
              children: [
                {
                  name: 'repair-list',
                  path: 'repair-list',
                  component: CmsRepairList,
                },
                {
                  name: 'add-repair',
                  path: 'add-repair',
                  component: CmsAddRepair,
                }
              ]
            }
          ]

        },
        {

          // cms-侧边栏菜单-库存
          name: 'inventory',
          path: 'inventory',
          redirect: '/admin/inventory/inventory-index',
          component: CmsInventory,
          children: [
            {

              name: 'inventory-index',
              path: 'inventory-index',
              redirect: '/admin/inventory/goods-inventory',
              component: CmsInventoryIndex
            },
            {
              name: 'goods-inventory',
              path: 'goods-inventory',
              component: CmsGoodsInventory
            },
            {
              name: 'storage',
              path: 'storage',
              component: CmsStorage,
              redirect: '/admin/inventory/storage/goods-storage',
              children: [
                {
                  name: 'goods-storage',
                  path: 'goods-storage',
                  component: CmsGoodsStorage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'storage-detail',
                  path: 'storage-detail',
                  component: CmsStorageDetail
                },
                {
                  name: 'increased-storage',
                  path: 'increased-storage',
                  component: CmsIncreasedStorage
                }
              ]
            },
            {
              name: 'goods-edit',
              path: 'goods-edit',
              component: CmsGoodsEdit
            },
            {
              name: 'outStorage',
              path: 'outStorage',
              component: CmsOutStorage,
              redirect: '/admin/inventory/outStorage/leave-storage',
              children: [
                {
                  name: 'leave-storage',
                  path: 'leave-storage',
                  component: CmsLeaveStorage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'outStorage-detail',
                  path: 'outStorage-detail',
                  component: CmsOutStorageDetail
                },
                {
                  name: 'increased-outStorage',
                  path: 'increased-outStorage',
                  component: CmsIncreasedOutStorage
                }
              ]
            },
            {
              name: 'warehouse-setting',
              path: 'warehouse-setting',
              component: CmsWarehouseSetting
            }
          ]
        },
        {

          // cms-侧边栏菜单-客户
          name: 'client',
          path: 'client',
          redirect: '/admin/client/client-index',
          component: CmsClient,
          children: [
            {
              name: 'client-index',
              path: 'client-index',
              redirect: '/admin/client/client-manage-index',
              component: CmsClientIndex
            },
            {
              name: 'client-manage-index',
              path: 'client-manage-index',
              redirect: '/admin/client/client-manage-index/client-manage',
              component: CmsClientManageIndex,
              children: [
                {
                  name: 'client-manage',
                  path: 'client-manage',
                  component: CmsClientManage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'client-detail',
                  path: 'client-detail',
                  component: CmsClientDetail
                },
                {
                  name: 'client-coupon',
                  path: 'client-coupon',
                  component: CmsClientCoupon
                },
                {
                  name: 'purchase-record',
                  path: 'purchase-record',
                  component: CmsPurchaseRecord
                },
              ]
            },
            {
              name: 'tag-manage',
              path: 'tag-manage',
              component: CmsTagManage
            },
            {
              name: 'client-grade',
              path: 'client-grade',
              component: CmsClientGrade
            },
            {
              name: 'login-statistics-index',
              path: 'login-statistics-index',
              component: CmsLoginStatisticsIndex,
              redirect: '/admin/client/login-statistics-index/login-statistics',
              children: [
                {
                  name: 'login-statistics',
                  path: 'login-statistics',
                  component: CmsLoginStatistics,
                },
                {
                  name: 'client-login',
                  path: 'client-login',
                  component: CmsLoginDetail
                }
              ]
            }
          ]
        },
        {

          // cms-侧边栏菜单-商城
          name: 'mall',
          path: 'mall',
          redirect: '/admin/mall/mall-index',
          component: CmsMall,
          children: [
            {

              name: 'mall-index',
              path: 'mall-index',
              redirect: 'mall-top',
              component: CmsMallIndex
            },
            {
              name: 'mall-top',
              path: 'mall-top',
              component: CmsMallTop,
              redirect: '/admin/mall/mall-top/mall-top-list',
              children: [
                {
                  name: 'mall-top-list',
                  path: 'mall-top-list',
                  component: CmsMallTopList,
                },
                {
                  name: 'add-mall-top',
                  path: 'add-mall-top',
                  component: CmsAddMallTop
                }
              ]
            },
            {
              name: 'mall-side',
              path: 'mall-side',
              component: CmsMallSide
            },
            {
              name: 'mall-bottom',
              path: 'mall-bottom',
              component: CmsMallBottom,
              redirect: '/admin/mall/mall-bottom/information-bar',
              children: [
                {
                  name: 'information-bar',
                  path: 'information-bar',
                  component: CmsInformationBar
                },
                {
                  name: 'edit-detail',
                  path: 'edit-detail',
                  component: CmsEditDetail
                }
              ]
            },
            {
              name: 'phone-decorate',
              path: 'phone-decorate',
              component: CmsPhoneDecorate
            },
            {
              name: 'customer-service',
              path: 'customer-service',
              component: CmsCustomerService
            },
            {
              name: 'phone-customize',
              path: 'phone-customize',
              component: CmsPhoneCustomize
            }
          ]
        },
        {
          // cms-侧边栏菜单-营销
          name: 'marketing',
          path: 'marketing',
          redirect: '/admin/marketing/marketing-index',
          component: CmsMarketing,
          children: [
            {
              name: 'marketing-index',
              path: 'marketing-index',
              redirect: '/admin/marketing/promotion',
              component: CmsMarketingIndex
            },
            {
              name: 'promotion',
              path: 'promotion',
              redirect: '/admin/marketing/promotion/goods-promotion',
              component: CmsPromotionIndex,
              children: [
                {
                  name: 'goods-promotion',
                  path: 'goods-promotion',
                  component: CmsGoodsPromotion,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'add-promotion',
                  path: 'add-promotion',
                  component: CmsAddPromotion
                }
              ]
            },
            {
              name: 'goods-recommend',
              path: 'goods-recommend',
              component: CmsGoodsRecommend
            },
            {
              name: 'package-index',
              path: 'package-index',
              component: CmsPackageIndex,
              redirect: '/admin/marketing/package-index/package-manage',
              children: [
                {
                  name: 'package-manage',
                  path: 'package-manage',
                  component: CmsPackageManage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'add-package',
                  path: 'add-package',
                  component: CmsAddPackage
                },
                {
                  name: 'package-detail',
                  path: 'package-detail',
                  component: CmsPackageDetail
                }
              ]
            },
            {
              name: 'advertising-popup',
              path: 'advertising-popup',
              component: CmsAdvertisingPopup
            },
            {
              name: 'coupon',
              path: 'coupon',
              component: CmsCouponIndex,
              redirect: '/admin/marketing/coupon/coupon-list',
              children: [
                {
                  name: 'coupon-list',
                  path: 'coupon-list',
                  component: CmsCouponList,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'coupon-detail',
                  path: 'coupon-detail',
                  component: CmsCouponDetail
                },
                {
                  name: 'add-coupon',
                  path: 'add-coupon',
                  component: CmsAddCoupon
                },
                {
                  name: 'assign-coupon',
                  path: 'assign-coupon',
                  component: CmsAssignCoupon
                }
              ]
            },
            {
              name: 'bidding-activities',
              path: 'bidding-activities',
              component: CmsBiddingActivitiesIndex,
              redirect: '/admin/marketing/bidding-activities/biddingActivities',
              children: [
                {
                  name: 'biddingActivities',
                  path: 'biddingActivities',
                  component: CmsBiddingActivities,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'biddingDetails',
                  path: 'biddingDetails',
                  component: CmsBiddingDetails,
                },
                {
                  name: 'review',
                  path: 'review',
                  component: Review,
                },
                {
                  name: 'shortlist',
                  path: 'shortlist',
                  component: Shortlist,
                }
              ]
            },
            {
              name: 'stand-activity',
              path: 'stand-activity',
              component: CmsStandActivityIndex,
              redirect: '/admin/marketing/stand-activity/standActivity',
              children: [
                {
                  name: 'standActivity',
                  path: 'standActivity',
                  component: CmsStandActivity,
                },
                {
                  name: 'addGoods',
                  path: 'addGoods',
                  component: CmsStandAddGoods,
                },
                {
                  name: 'lookDetails',
                  path: 'lookDetails',
                  component: CmsStandLookDetails,
                }
              ]
            }
          ]
        },
        {
          // cms-侧边栏菜单-数据
          name: 'datas',
          path: 'datas',
          redirect: '/admin/datas/datas-index',
          component: CmsDatas,
          children: [
            {

              name: 'datas-index',
              path: 'datas-index',
              redirect: '/admin/datas/data',
              component: CmsDatasIndex
            },
            {

              name: 'data',
              path: 'data',
              component: CmsData
            }
          ]
        },
        {
          // cms-侧边栏菜单-设置
          name: 'setting',
          path: 'setting',
          redirect: '/admin/setting/setting-index',
          component: CmsSetting,
          children: [
            {
              name: 'setting-index',
              path: 'setting-index',
              redirect: '/admin/setting/department',
              component: CmsSettingIndex
            },
            // 部门管理
            {
              name: 'department',
              path: 'department',
              redirect: '/admin/setting/department/department-manage',
              component: CmsDepartment,
              children: [
                {
                  name: 'department-manage',
                  path: 'department-manage',
                  component: CmsDepartmentManage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'department-authority',
                  path: 'department-authority',
                  component: CmsDepartmentAuthority
                }
              ]
            },
            // 员工管理
            {
              name: 'employee',
              path: 'employee',
              redirect: '/admin/setting/employee/employee-manage',
              component: CmsEmployee,
              children: [
                {
                  name: 'employee-manage',
                  path: 'employee-manage',
                  component: CmsEmployeeManage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'employee-authority',
                  path: 'employee-authority',
                  component: CmsEmployeeAuthority
                },
                {
                  name: 'employee-add-account',
                  path: 'employee-add-account',
                  component: CmsEmployeeAddAccount
                },
                {
                  name: 'employee-revise-account',
                  path: 'employee-revise-account',
                  component: CmsEmployeeReviseAccount
                }
              ]
            },
            {
              name: 'online-pay',
              path: 'online-pay',
              component: CmsOnlinePay
            },
            {
              name: 'offline-pay',
              path: 'offline-pay',
              component: CmsOfflinePay
            },
            {
              name: 'business-setting',
              path: 'business-setting',
              component: CmsBusinessSetting
            },
            {
              name: 'system-setting',
              path: 'system-setting',
              component: CmsSystemSetting
            }
          ]
        },
        {
          // cms-侧边栏菜单-应用
          name: 'apply',
          path: 'apply',
          redirect: '/admin/apply/apply-menu',
          component: CmsApply,
          children: [
            {
              name: 'apply-menu',
              path: 'apply-menu',
              component: CmsApplyMenu
            },
            {
              name: 'logistics-introduce',
              path: 'logistics-introduce',
              component: CmsLogisticsIntroduce
            },
            {
              name: 'ERP-introduce',
              path: 'ERP-introduce',
              component: CmsERPIntroduce
            },
            {
              name: 'ERP-configure',
              path: 'ERP-configure',
              component: CmsERPConfigure
            },
            {
              name: 'supplier-introduce',
              path: 'supplier-introduce',
              component: CmsSupplierIntroduce
            },
            {
              name: 'supplier-configure',
              path: 'supplier-configure',
              component: CmsSupplierConfigure
            },
            {
              name: 'selection-introduce',
              path: 'selection-introduce',
              component: CmsSelectionIntroduce
            },
            {
              name: 'distribution-introduce',
              path: 'distribution-introduce',
              component: CmsDistributionIntroduce
            },
            {
              name: 'integral-content',
              path: 'integral-content',
              component: CmsIntegralContent
            },
            {
              name: 'points-account',
              path: 'points-account',
              component: CmsPointsAccount
            },
            {
              name: 'integray-detailed',
              path: 'integray-detailed',
              component: CmsIntegralDetailed
            },
            {
              name: 'integral-setting-list',
              path: 'integral-setting-list',
              component: CmsIntegralSettingList
            },
            {
              name: 'integral-setting',
              path: 'integral-setting',
              component: CmsIntegralSetting
            },
          ]
        }
      ]
    },
    {
      name: '/supplier/spl-user',
      path: '/supplier/spl-user',
      redirect: '/supplier/spl-user/spl-login',
      component: SplUserLogin,
      children: [
        {
          name: "spl-login",
          path: 'spl-login',
          component: SplLogin
        }, {
          name: "spl-register",
          path: 'spl-register',
          component: SplRegister
        }, {
          name: "spl-password",
          path: 'spl-password',
          component: SplPassword
        }
      ]
    },
    {
      path: '/supplier',
      component: SplViewsIndex,
      redirect: '/supplier/spl-goods',
      children: [
        {
          name: 'spl-goods',
          path: 'spl-goods',
          redirect: '/supplier/spl-goods/goods-index',
          component: SplGoods,
          children: [
            {
              name: 'goods-index',
              path: 'goods-index',
              redirect: '/supplier/spl-goods/goods-index/goods-list',
              component: SplList,
              children: [
                {
                  name: 'goods-list',
                  path: 'goods-list',
                  component: SplGoodsList,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'add-goods',
                  path: 'add-goods',
                  component: SplAddGoods
                }
              ]
            },
            {
              name: 'price-manage-index',
              path: 'price-manage-index',
              redirect: '/supplier/spl-goods/price-manage-index/price-manage',
              component: SplPriceManage,
              children: [
                {
                  name: 'price-manage',
                  path: 'price-manage',
                  component: SplPriceManageList,
                  meta: {
                    keepAlive: true
                  }
                },
              ]
            }
          ]
        },
        {
          name: 'spl-order',
          path: 'spl-order',
          redirect: '/supplier/spl-order/select-order',
          component: SplOrder,
          children: [
            {
              name: "select-order",
              path: 'select-order',
              component: SplSelectOrder
            },
            {
              name: "sample-from",
              path: 'sample-from',
              component: SplSampleOrderIndex,
              redirect: '/supplier/spl-order/sample-from/sample-order',
              children: [
                {
                  name: "sample-order",
                  path: 'sample-order',
                  component: SplSampleOrder
                },
                {
                  name: "sample-detail",
                  path: 'sample-detail',
                  component: SplsampleDetail
                }
              ]
            },
          ]
        },
        {
          // cms-侧边栏菜单-库存
          name: 'inventory',
          path: 'inventory',
          redirect: '/supplier/inventory/inventory-index',
          component: SqlInventory,
          children: [
            {

              name: 'inventory-index',
              path: 'inventory-index',
              redirect: '/supplier/inventory/goods-inventory',
              component: SqlInventoryIndex
            },
            {
              name: 'goods-inventory',
              path: 'goods-inventory',
              component: SqlGoodsInventory
            },
            {
              name: 'storage',
              path: 'storage',
              component: SqlStorage,
              redirect: '/supplier/inventory/storage/goods-storage',
              children: [
                {
                  name: 'goods-storage',
                  path: 'goods-storage',
                  component: SqlGoodsStorage,
                  meta: {
                    keepAlive: true
                  }
                },
                {
                  name: 'storage-detail',
                  path: 'storage-detail',
                  component: SqlStorageDetail
                },
                {
                  name: 'increased-storage',
                  path: 'increased-storage',
                  component: SqlIncreasedStorage
                }
              ]
            },
            {
              name: 'goods-edit',
              path: 'goods-edit',
              component: SqlGoodsEdit
            }
          ]
        },
        {
          name: 'spl-bidding',
          path: 'spl-bidding',
          redirect: '/supplier/spl-bidding/bidding-index',
          component: SplBidding,
          children: [
            {
              name: "bidding-index",
              path: 'bidding-index',
              component: SplBiddingActivitiesIndex,
              redirect: '/supplier/spl-bidding/bidding-index/bidding-activities',
              children: [
                {
                  name: "bidding-activities",
                  path: 'bidding-activities',
                  component: SplBiddingActivities
                },
                {
                  name: "bidding-details",
                  path: 'bidding-details',
                  component: SplBiddingDetails
                },
                {
                  name: "rule",
                  path: 'rule',
                  component: SplBiddingModifyRule
                }
              ]
            },
            {
              name: 'stand-index',
              path: 'stand-index',
              component: SplBiddingStandIndex,
              redirect: '/supplier/spl-bidding/stand-index/bidding-stand',
              children: [
                {
                  name: "bidding-stand",
                  path: 'bidding-stand',
                  component: SplBiddingStandBidding,
                },
                {
                  name: "stand-details",
                  path: 'stand-details',
                  component: SplStandDetails
                }
              ]
            },
            {
              name: "bidding-message",
              path: 'bidding-message',
              component: SplBiddingMessage
            }
          ]
        },
        {
          name: 'spl-account',
          path: 'spl-account',
          redirect: '/supplier/spl-account/account-update',
          component: SplAccount,
          children: [
            {
              name: "account-update",
              path: 'account-update',
              component: SplAccountUpdate
            }
          ]
        }
      ]
    },
    {
      path: '*',
      name: '*',
      component: Page404
    }
  ]
});

router.afterEach((to, from) => {
  if (to.meta.keepAlive) {
    setTimeout(() => {
      document.getElementById('link-content').scrollTop = to.meta.scrollTop;
      // console.log(document.getElementById('link-content').scrollTop);
    }, 0)
  } else {
    if (from.meta.keepAlive) {
      from.meta.scrollTop = document.getElementById('link-content').scrollTop
    }
  }
}
)

export default router
